import * as React from 'react';
import Member from '../Models/Member';
import MemberAddress from '../MakeDonation/Types/MemberAddress';
import Row from '../Components/Row';
import TextInput from '../Components/TextInput';
import Select from '../Components/Select';
import CountrySelect from '../Components/CountrySelect';
import Validator from '../Helpers/validator';
import Country from '../MakeDonation/Types/Country';
import CountryListSelect from '../Components/CountryListSelect';

interface Props {
    member: Member;

    locatedAddresses: { Id: string; Text: string }[];
    didAddressSearch: boolean;
    isAddressFinderEnabled: boolean;
    postalAdddressBackgroundClass?: string;
    countryList?: Country[];

    handleAddressSelect: (postcodeid: string) => Promise<void>;
    handlePostcodeLookup: (postCode: string, countryCode?: string) => void;
    updateMemberAddress(mutate: (MemberAddress: MemberAddress) => void): void;
}

interface State {
    selectedAddressId: string;
    postCodeLabel?: string;
    validateMessage?: string;
    isPostcodeMandatory?: boolean;
    isRegexValidation?: boolean;
    validateRegex?: RegExp;
    isloqateValidationForPostCode?: boolean;
}

class BarnardosAddressModule extends React.Component<Props, State> {
    postCodeClassValue: string = '';

    constructor(props: Props) {
        super(props);

        this.state = {
            selectedAddressId: '',
            isPostcodeMandatory: this.setMandatoryPostCode(),
            isRegexValidation: this.setRegexValidation(),
            isloqateValidationForPostCode: this.setPostCodeLoqateValidation(),
        };
    }
    updatePostCodeState(postCode: string) {
        this.postCodeClassValue = postCode;
        // tslint:disable-next-line:no-console
        console.log(this.postCodeClassValue);
        // this.setState({postCodeValue: postCode});
    }
    renderAddressSelect() {
        if (this.props.locatedAddresses.length === 0) {
            if (this.props.didAddressSearch === true) {
                return <span>No address found.</span>;
            }

            return;
        }

        return (
            <div className="input-field">
                <Select
                    value={this.state.selectedAddressId}
                    onChange={(selectedAddressId: string) => {
                        this.setState({ selectedAddressId: selectedAddressId });
                        this.props.handleAddressSelect(selectedAddressId);
                    }}
                >
                    <option>Select an Address</option>
                    {this.renderAddressOptions()}
                </Select>
            </div>
        );
    }

    updatePostCodeLabel = (label: string, mandatory: boolean) => {
        if (mandatory) {
            this.setState({ postCodeLabel: label + '*' });
        } else {
            this.setState({ postCodeLabel: label });
        }
    }

    setPostCodeLabel(): string {
        const countryDetails = this.props.countryList && this.props.countryList
            .find(details => details.ISO3Code === this.props.member.address.countryIso);
        if (countryDetails !== undefined) {
            return countryDetails.isCodeMandatory ? countryDetails.fieldLabel + '*' : countryDetails.fieldLabel;
        } else {
            const othersDetail = this.props.countryList && this.props.countryList
                .find(details => details.countryName === 'Other');
            if (othersDetail !== undefined) {
                return othersDetail.isCodeMandatory ? othersDetail.fieldLabel + '*' : othersDetail.fieldLabel;
            } else {
                return 'Postcode*';
            }
        }
    }

    updateValidateMessage = (message: string) => {
        this.setState({ validateMessage: message });
    }

    setValidateMessage(): string {
        const countryDetails = this.props.countryList && this.props.countryList
            .find(details => details.ISO3Code === this.props.member.address.countryIso);
        if (countryDetails !== undefined) {
            return countryDetails.validationMessage ? countryDetails.validationMessage : '';
        } else {
            const othersDetail = this.props.countryList && this.props.countryList
                .find(details => details.countryName === 'Other');
            if (othersDetail !== undefined) {
                return othersDetail.validationMessage ? othersDetail.validationMessage : '';
            } else {
                return '';
            }
        }
    }

    updateRegexValidation = (regex?: string) => {
        if (regex !== undefined) {
            this.setState({ isRegexValidation: true, validateRegex: new RegExp(regex) });
        } else {
            this.setState({ isRegexValidation: false, validateRegex: regex });
        }
    }

    setValidateRegexValue(): RegExp {
        const countryDetails = this.props.countryList && this.props.countryList
            .find(details => details.ISO3Code === this.props.member.address.countryIso);
        if (countryDetails !== undefined && countryDetails.regex !== undefined) {
            return countryDetails.regex ? new RegExp(countryDetails.regex) : new RegExp('');
        } else {
            const othersDetail = this.props.countryList && this.props.countryList
                .find(details => details.countryName === 'Other');
            if (othersDetail !== undefined) {
                return othersDetail.regex ? new RegExp(othersDetail.regex) : new RegExp('');
            } else {
                return new RegExp('');
            }
        }
    }

    setRegexValidation(): boolean {
        const countryDetails = this.props.countryList && this.props.countryList
            .find(details => details.ISO3Code === this.props.member.address.countryIso);
        if (countryDetails !== undefined && countryDetails.regex !== undefined) {
            return true;
        } else {
            const othersDetail = this.props.countryList && this.props.countryList
                .find(details => details.countryName === 'Other');
            if (othersDetail !== undefined && othersDetail.regex !== undefined) {
                return true;
            } else {
                return false;
            }
        }
    }

    updateMandatoryPostCode = (codeMandatory: boolean) => {
        this.setState({ isPostcodeMandatory: codeMandatory });
    }

    setMandatoryPostCode(): boolean {
        const countryDetails = this.props.countryList && this.props.countryList
            .find(details => details.ISO3Code === this.props.member.address.countryIso);
        if (countryDetails !== undefined) {
            return true;
        } else {
            const othersDetail = this.props.countryList && this.props.countryList
                .find(details => details.countryName === 'Other');
            if (othersDetail !== undefined) {
                return true;
            } else {
                return false;
            }
        }
    }

    updatePostCodeLoqateValidation = (validationValue: boolean) => {
        this.setState({ isloqateValidationForPostCode: validationValue });
    }

    setPostCodeLoqateValidation(): boolean {
        const countryDetails = this.props.countryList && this.props.countryList
            .find(details => details.ISO3Code === this.props.member.address.countryIso);
        if (countryDetails !== undefined && countryDetails.validate) {
            return true;
        } else {
            const othersDetail = this.props.countryList && this.props.countryList
                .find(details => details.countryName === 'Other');
            if (othersDetail !== undefined && othersDetail.validate) {
                return true;
            } else {
                return false;
            }
        }
    }

    renderCountry() {
        if (this.props.countryList !== undefined) {
            return (
                <CountryListSelect
                    key={'country'}
                    id={'country'}
                    iso3Code={this.props.member.address.countryIso}
                    divClasses="col s12 m6 l6"
                    onChange={country =>
                        this.props.updateMemberAddress(memberAddress => {
                            memberAddress.country = country.countryName;
                            memberAddress.countryIso = country.ISO3Code ? country.ISO3Code : '';
                        })
                    }
                    countryList={this.props.countryList}
                    validator={Validator.isNotEmpty}
                    dataInvalidMessage={'Country is required.'}
                    updatePostCodeLabel={this.updatePostCodeLabel}
                    updateValidateMessage={this.updateValidateMessage}
                    updateRegexValidation={this.updateRegexValidation}
                    updateMandatoryPostCode={this.updateMandatoryPostCode}
                    updatePostCodeLoqateValidation={this.updatePostCodeLoqateValidation}
                />
            );
        } else {
            return (
                <CountrySelect
                    key={'country'}
                    id={'country'}
                    iso2Code={this.props.member.address.countryIso}
                    divClasses="col s12 m6 l6"
                    onChange={countryDetails =>
                        this.props.updateMemberAddress(memberAddress => {
                            memberAddress.country = countryDetails.countryName;
                            memberAddress.countryIso = countryDetails.iso2Code;
                        })
                    }
                    validator={Validator.isNotEmpty}
                    dataInvalidMessage={'Country is required.'}
                />
            );
        }
    }

    renderAddressOptions() {
        return this.props.locatedAddresses.map((address, index) => {
            return (
                <option key={index} id={`${index}`} value={address.Id}>
                    {address.Text}
                </option>
            );
        }
        );
    }

    render() {
        let enablePostcodeSearch = Validator.isNotEmpty(
            this.props.member.address.postcode
        );
        let pcClass = enablePostcodeSearch ? '' : 'disabled';

        let postcodeFinderClass = 'postcode-block ';
        if (this.props.postalAdddressBackgroundClass) {
            postcodeFinderClass += this.props.postalAdddressBackgroundClass;
        }

        return (
            <Row>
                {this.props.isAddressFinderEnabled && <><Row className={postcodeFinderClass}>
                    <Row>
                        {this.props.countryList !== undefined ?
                            <TextInput
                                key={'postcode'}
                                id={'postcode'}
                                value={this.props.member.address.postcode}
                                label={this.state.postCodeLabel ? this.state.postCodeLabel : this.setPostCodeLabel()}

                                divClasses={'col s12 m6'}

                                onChange={v => { this.props.updateMemberAddress(o => (o.postcode = v)); }}
                                onChangeImmediate={v => { this.updatePostCodeState(v); }}
                                validator={this.state.isPostcodeMandatory ? Validator.isNotEmpty : undefined}
                                showUppercase={true}
                                handlePostcodeLookup={() => { this.props.handlePostcodeLookup(this.postCodeClassValue, this.props.member.address.countryIso); }}
                                dataInvalidMessage={this.state.validateMessage ? this.state.validateMessage : this.setValidateMessage()}
                                regexValidator={this.state.isRegexValidation ? Validator.isValidatePostCodeRegex : undefined}
                                validateRegex={this.state.validateRegex ? this.state.validateRegex : this.setValidateRegexValue()}
                            />
                            : <TextInput
                                key={'postcode'}
                                id={'postcode'}
                                value={this.props.member.address.postcode}
                                label={'Postcode*'}
                                divClasses={'col s12 m6'}
                                onChange={v => { this.props.updateMemberAddress(o => (o.postcode = v)); }}
                                onChangeImmediate={v => { this.updatePostCodeState(v); }}
                                validator={Validator.isNotEmpty}
                            />
                        }
                        <span className="col s12 m6">
                            <a
                                className={`btn ${pcClass} secondary`}
                                onClick={() => { this.props.handlePostcodeLookup(this.postCodeClassValue, this.props.member.address.countryIso); }}
                            >
                                <i className="material-icons">search</i>
                                FIND ADDRESS
                            </a>
                        </span>
                    </Row>
                    {this.renderAddressSelect()}
                </Row>

                    <span className="manual-address-entry">
                        Or enter address manually:
                    </span></>}

                <TextInput
                    key={'line1'}
                    id={'line1'}
                    value={this.props.member.address.line1}
                    label={'Address Line 1*'}
                    divClasses={'col s12'}
                    onChange={v => this.props.updateMemberAddress(m => (m.line1 = v))}
                    validator={Validator.isNotEmpty}
                    dataInvalidMessage={'Address Line 1 is required.'}
                />

                <TextInput
                    key={'line2'}
                    id={'line2'}
                    value={this.props.member.address.line2}
                    label={'Address Line 2'}
                    divClasses={'col s12'}
                    onChange={v => this.props.updateMemberAddress(m => (m.line2 = v))}
                />

                <TextInput
                    key={'town'}
                    id={'town'}
                    value={this.props.member.address.town}
                    label={'Town*'}
                    divClasses={'col s6 m6'}
                    onChange={v => this.props.updateMemberAddress(m => (m.town = v))}
                    validator={Validator.isNotEmpty}
                    dataInvalidMessage={'Town is required.'}
                />

                <TextInput
                    key={'county'}
                    id={'county'}
                    value={this.props.member.address.county}
                    label={'County'}
                    divClasses={'col s6 m6'}
                    onChange={v => this.props.updateMemberAddress(m => (m.county = v))}
                />

                {this.renderCountry()}
                {this.props.countryList !== undefined ?
                    <TextInput
                        id="postcode2"
                        value={this.props.member.address.postcode}
                        label={this.state.postCodeLabel ? this.state.postCodeLabel : this.setPostCodeLabel()}
                        divClasses={'col s12 m6 l6 marginTop30'}
                        onChange={v => { this.props.updateMemberAddress(m => (m.postcode = v)); }}
                        onChangeImmediate={v => { this.updatePostCodeState(v); }}
                        validator={this.state.isPostcodeMandatory ? Validator.isNotEmpty : undefined}
                        showUppercase={true}
                        handlePostcodeLookup={() => { this.props.handlePostcodeLookup(this.postCodeClassValue, this.props.member.address.countryIso); }}
                        dataInvalidMessage={this.state.validateMessage ? this.state.validateMessage : this.setValidateMessage()}
                        regexValidator={this.state.isRegexValidation ? Validator.isValidatePostCodeRegex : undefined}
                        validateRegex={this.state.validateRegex ? this.state.validateRegex : this.setValidateRegexValue()}
                    />
                    : <TextInput
                        id="postcode2"
                        value={this.props.member.address.postcode}
                        label="PostCode*"
                        divClasses={'col s12 m6 l6 marginTop30'}
                        onChange={v => { this.props.updateMemberAddress(m => (m.postcode = v)); }}
                        onChangeImmediate={v => { this.updatePostCodeState(v); }}
                        dataInvalidMessage="A valid postcode is required."
                    />
                }
            </Row>
        );
    }
}

export default BarnardosAddressModule;



// WEBPACK FOOTER //
// ./src/Modules/BarnardosAddressModule.tsx